declare namespace $ {

	type $mol_form_field__name_shm_hitalama_map_widget_float_form_custom_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_name'] >
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_form_custom_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['Field_content'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_button_major__title_shm_hitalama_map_widget_float_form_custom_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_map_widget_float_form_custom_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['submit'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__enabled_shm_hitalama_map_widget_float_form_custom_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['submit_allowed'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_form_custom_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_form_custom_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['clear'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_form__form_fields_shm_hitalama_map_widget_float_form_custom_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['form_fields'] >
		,
		ReturnType< $mol_form['form_fields'] >
	>
	type $mol_form__buttons_shm_hitalama_map_widget_float_form_custom_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['buttons'] >
		,
		ReturnType< $mol_form['buttons'] >
	>
	type $mol_string__value_shm_hitalama_map_widget_float_form_custom_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_value'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_form_custom_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_value'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_date__value_shm_hitalama_map_widget_float_form_custom_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_value'] >
		,
		ReturnType< $mol_date['value'] >
	>
	type __shm_hitalama_map_widget_float_form_custom_13 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_widget_float_form_custom['period_str'] >[0]
		,
		Parameters< $shm_hitalama_map_widget_float_form_custom['Period'] >[0]
	>
	type $shm_period__period_shm_hitalama_map_widget_float_form_custom_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_value'] >
		,
		ReturnType< $shm_period['period'] >
	>
	type $shm_hitalama_file_attach__files_shm_hitalama_map_widget_float_form_custom_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_files'] >
		,
		ReturnType< $shm_hitalama_file_attach['files'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_form_custom_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_form_custom_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['buttons_visible'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	export class $shm_hitalama_map_widget_float_form_custom extends $shm_hitalama_map_widget_float {
		field_name( id: any): string
		Field_content( id: any): $mol_view
		Field( id: any): $mol_form_field
		form_fields( ): readonly(any)[]
		submit( next?: any ): any
		submit_allowed( ): boolean
		Publish( ): $mol_button_major
		clear( next?: any ): any
		Clear( ): $mol_button_minor
		buttons( ): readonly(any)[]
		Form( ): $mol_form
		field_value( id: any, next?: any ): any
		String( id: any): $mol_string
		Textarea( id: any): $mol_textarea
		Date( id: any): $mol_date
		period_str( id: any): ReturnType< ReturnType< $shm_hitalama_map_widget_float_form_custom['Period'] >['period_str'] >
		Period( id: any): $shm_period
		field_files( id: any, next?: readonly(any)[] ): readonly(any)[]
		File( id: any): $shm_hitalama_file_attach
		buttons_visible( next?: boolean ): boolean
		Buttons_visible( ): $mol_check_box
		controls( ): readonly(any)[]
		custom( ): $shm_hitalama_map_widget_entity_form_custom
		Content_by_type( id: any): ({ 
			'any': ReturnType< $shm_hitalama_map_widget_float_form_custom['String'] >,
			'string': ReturnType< $shm_hitalama_map_widget_float_form_custom['String'] >,
			'textarea': ReturnType< $shm_hitalama_map_widget_float_form_custom['Textarea'] >,
			'date': ReturnType< $shm_hitalama_map_widget_float_form_custom['Date'] >,
			'period': ReturnType< $shm_hitalama_map_widget_float_form_custom['Period'] >,
			'file': ReturnType< $shm_hitalama_map_widget_float_form_custom['File'] >,
		}) 
		settings_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=custom.view.tree.d.ts.map